<template>
  <v-app dark>
    <v-content>
      <FiveCrowns/>
    </v-content>
  </v-app>
</template>

<script>
import FiveCrowns from './components/FiveCrowns'

export default {
  name: 'App',
  components: {
    FiveCrowns
  }
}
</script>
